<template>
  <!-- 報告書一括出力 履歴 -->
  <div id="AppReportPrintHistory">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">報告書印刷履歴</label>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field horizontal label="件数" style="float:right; white-space:nowrap;">
            <b-select position="is-right" v-model="perPage">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
            </b-select>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-table
            :data="data"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :pagination-size="paginationSize"
            :default-sort-direction="defaultSortDirection"
            default-sort="printDate"
            detailed
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="printDate" label="印刷実行日" sortable centered>{{ props.row.date }}</b-table-column>
              <b-table-column
                field="staffName"
                label="印刷実行者"
                sortable
                centered
              >{{ props.row.printStaffName }}</b-table-column>
              <b-table-column
                field="printKind"
                label="印刷種別"
                sortable
                centered
              >{{ props.row.printKind|printingKindFillter }}</b-table-column>
              <b-table-column field="productName" label="点検機器" sortable>{{ props.row.productName }}</b-table-column>
              <b-table-column
                field="inspectionKind"
                label="点検種別"
                sortable
              >{{ props.row.inspectionKind | inspectionTypeFillter}}</b-table-column>
              <b-table-column
                field="staffName"
                label="点検担当者"
                sortable
                centered
              >{{ props.row.staffName }}</b-table-column>
              <b-table-column
                field="patientName"
                label="患者名"
                sortable
                centered
              >{{ props.row.patientName }}</b-table-column>
            </template>
            <template slot="detail" slot-scope="props">
              <div class="content">
                <table style="table-layout: fixed;">
                  <tr>
                    <th style="width:250px;">点検管理番号</th>
                    <td>{{ props.row.inspectionCode }}</td>
                  </tr>
                  <!--
                  <tr>
                    <th style="width:250px;">送付先</th>
                    <td>{{ props.row.address }}</td>
                  </tr>
                  -->
                  <tr>
                    <th>医療機関名</th>
                    <td>{{ props.row.hospitalName }}</td>
                  </tr>
                  <tr>
                    <th>点検実施日</th>
                    <td>{{ props.row.completionDate }}</td>
                  </tr>
                </table>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <!-- 戻るボタン -->
    <div style="text-align:center;">
      <b-button v-on:click="back" class="button" type="is-primary" native-type="button">戻る</b-button>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
export default {
  name: "AppReportPrintHistory",
  methods: {
    back: function(event) {
      this.$router.push({
        name: "AppReportbatchPrintSearch",
        params: { searchConditions: this.searchConditions }
      });
    },
    getReportDownloadHistoryPOST: function(client) {
      var objList = [];
      for (var i = 0; this.item.length > i; i++) {
        objList.push({
          inspectionId: this.item[i].inspectionCode,
          printType: this.item[i].kind
        });
      }
      return client.apis.apiInspection.getReportDownloadHistoryPOST({
        body: objList
      });
    },
    getDownloadHistorySuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
    },
    getDownloadHistoryError: function(result) {
      this.showErrorMessage(result);
    }
  },
  data() {
    var item = this.$route.params["item"];
    var searchConditions = this.$route.params["searchConditions"];
    return {
      data: [
        {
          printDate: "",
          printStaff: "",
          printKind: "",
          inspectionCode: "",
          productName: "",
          inspectionKind: "",
          address: "",
          form: "",
          patientName: "",
          hospitalName: "",
          officeName: "",
          staffName: "",
          completionDate: ""
        }
      ],
      item,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 10,
      searchConditions
    };
  },
  filters: {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  mounted: function() {
    // getReportDownloadHistoryPOST
    // this.dataに結果設定
    var excuteApi = this.getReportDownloadHistoryPOST;
    var successCallBack = this.getDownloadHistorySuccess;
    var errorCallBack = this.getDownloadHistoryError;
    // WebAPI Call
    this.apiCall(excuteApi, successCallBack, errorCallBack);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppReportPrintHistory.vue